import request from 'services/request';

export async function pricesMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/Prices/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}
